<template>
  <div class="container">
    <div class="flex userbox">
      <div class="head_img">
        <img :src="userInfo.head_img" alt />
      </div>
      <div style="width: 240px; margin-left: 20px">
        <div>
          <span class="user_title">用户昵称：</span>
          <span>{{ userInfo.nick_name }}</span>
        </div>
        <div style="margin: 10px 0">
          <span class="user_title">性别：</span>
          <span v-if="userInfo.sex == 1">男</span>
          <span v-if="userInfo.sex == 2">女</span>
          <span v-if="!userInfo.sex">未知</span>
        </div>
        <div>
          <span class="user_title">手机号：</span>
          <span>{{ userInfo.phone }}</span>
        </div>
      </div>
      <div>
        <div>
          <span class="user_title">注册时间：</span>
          <span>{{ userInfo.reg_time }}</span>
        </div>
        <div style="margin: 10px 0">
          <span class="user_title">真实姓名：</span>
          <span>{{ userInfo.real_name }}</span>
        </div>

        <div>
          <span class="user_title">身份证号：</span>
          <span>{{ userInfo.id_card }}</span>
        </div>
      </div>
    </div>
    <div class="item">
      <div>
        <span class="gray">患者姓名：</span>
        <span>{{ detail.real_name }}</span>
      </div>
      <div>
        <span class="gray">性别：</span>
        <span v-if="detail.sex == 1">男</span>
        <span v-if="detail.sex == 2">女</span>
        <span v-if="detail.sex == 0">未知</span>
      </div>
      <div>
        <span class="gray">关系：</span>
        <span>
          （患者是用户的）
          <span v-if="detail.relationship == 1">本人</span>
          <span v-if="detail.relationship == 2">爸爸</span>
          <span v-if="detail.relationship == 3">妈妈</span>
          <span v-if="detail.relationship == 4">老公</span>
          <span v-if="detail.relationship == 5">老婆</span>
          <span v-if="detail.relationship == 6">女儿</span>
          <span v-if="detail.relationship == 7">儿子</span>
          <span v-if="detail.relationship == 8">朋友</span>
          <span v-if="detail.relationship == 9">家人</span>
        </span>
      </div>
    </div>
    <div class="item">
      <div>
        <span class="gray">出生日期：</span>
        <span>{{ detail.birthday }}</span>
      </div>
      <div>
        <span class="gray">年龄：</span>
        <span>{{ detail.age }}</span>
      </div>
      <div>
        <span class="gray">证件类型：</span>
        <span>{{ detail.id_card_type | idCardTypeText }}</span>
      </div>
      <div>
        <span class="gray">证件号码：</span>
        <span>{{ detail.id_card }}</span>
      </div>
    </div>
    <div class="item">
      <div style="width: 100%">
        <span class="gray">既往病史：</span>
        <span>{{ detail.history_name }}</span>
      </div>
    </div>
    <div class="item">
      <div style="width: 100%">
        <span class="gray">过敏病史：</span>
        <span>{{ detail.allergen_name }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import patient from "../../../api/patient";
import dayjs from "dayjs";
export default {
  data() {
    return {
      detail: {},
      userInfo: {},
    };
  },
  filters: {
    idCardTypeText(val) {
      switch (val) {
        case 1:
          return "大陆身份证";
        case 2:
          return "香港身份证";
        case 3:
          return "澳门身份证";
      }
    },
  },
  methods: {
    getDetail() {
      let patient_id = this.$route.query.patient_id;
      let user_id = this.$route.query.user_id;
      patient.patientItem({ patient_id }).then((res) => {
        if (res.code == 0) {
          this.detail = res.data.info;
        }
      });
      this.axios.post("platform/patient/userItem", { user_id }).then((res) => {
        if (res.code == 0) {
          this.userInfo = res.data.info;
          this.userInfo.reg_time = this.userInfo.reg_time
            ? dayjs.unix(this.userInfo.reg_time).format("YYYY-MM-DD HH:mm")
            : "";
        }
      });
    },
  },
  created() {
    this.getDetail();
  },
};
</script>
<style lang="scss" scoped>
.container {
  text-align: left;
  padding: 20px;
  box-sizing: border-box;
}
.userbox {
  align-items: center;
  margin-bottom: 20px;
  background: #ebf6e9;
  padding: 5px 0;
}
.head_img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  img {
    width: 120px;
    height: 120px;
  }
}
.item {
  display: flex;
  margin-bottom: 14px;
  div {
    width: 220px;
  }
}
.gray {
  color: #747981;
}
</style>